import { useState } from 'react';
import { Modal, Form, Row, Col, InputNumber, message } from 'antd';
import LoadingButton from '@mui/lab/LoadingButton';
import { backendPostWithoutRefresh } from '../../helpers/callBackend';
import { toPrice } from '../../helpers/stringFormat';
import Button from '@mui/material/Button';

const UpdateManualAccountBalance = (props) => {
  const [visible, setVisible] = useState(false)

  return (
    <>
      <div
        style={{
          border: "0px",
          padding: "0px",
          cursor: "pointer",
        }}
        onClick={() => setVisible(true)}
      >
        {props.button}
      </div>

      {(visible) && (
        <ModalComponent
          title={"Update Manual Account Balance"}
          visible={visible}
          onCancel={() => setVisible(false)}
          closeModal={() => setVisible(false)}
          bankId={props.bankId}
          balance={props.balance}
          updateBalanceSuccess={props.updateBalanceSuccess}
        />
      )}
    </>
  );
};

const ModalComponent = (props) => {
  const [newVal, setNewVal] = useState('');
  const [error, setError] = useState('');
  const [value, setValue] = useState(props.balance)
  const [refreshBalanceLoading, setRefreshBalanceLoading] = useState(false);

  const validate = (input) => {
    if (!/^\d+(\.\d{1,2})?$/.test(input)) {
      setError(`Balance must be a valid amount.`);
      message.error(error)
      return false;
    }
    setError('');
    return true;
  }

  const handleChange = (value) => {
    const input = value?.toString() || '';
    validate(input);
    setNewVal(input);
  };

  const validateAndSave = async (input) => {
    if (!validate(input)) {
      return;
    }
    try {
      setRefreshBalanceLoading(true);
      const raw = Number(input)
      const { data } = await backendPostWithoutRefresh("/api/bank-account/update/", { bank_account_id: props.bankId, last_available_balance: raw, last_current_balance: raw });
      if (data) {
        props.updateBalanceSuccess(data);
        setRefreshBalanceLoading(false);
        setValue(input);
        setNewVal("");
        props.closeModal()
      }
    } catch (err) {
      setError("Save not successful. Try again.");
      message.error(error);
    }
  };

  const handleSubmit = () => {
    validateAndSave(newVal);
  };

  const content = <div>
    <Row gutter={0}>
      <Col span={24}>
        <Form.Item
          label="Current Balance"
          rules={[{ required: true }]}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <InputNumber
              style={{ width: "100%", height: "30px" }}
              onChange={handleChange}
              formatter={(input) => {
                return input
                  ? `$ ${input}`.replace(
                    /\B(?=(\d{3})+(?!\d))/g,
                    ","
                  )
                  : null;
              }}
              parser={(input) => {
                const parsedInput = input.replace(/\$\s?|(,*)/g, "");
                return parsedInput.match(/^\d*\.?\d*$/) ? parsedInput : "";
              }}
              placeholder={toPrice(value)}
            />
            <LoadingButton
              sx={{ fontSize: 12, textTransform: 'none', height: "30px" }}
              disableElevation
              size="small"
              type="submit"
              variant="contained"
              color="primary"
              onClick={handleSubmit}
              disabled={!newVal || error}
              loading={refreshBalanceLoading}
            >
              Save
            </LoadingButton>
            <Button
              sx={{ fontSize: 12, textTransform: 'none', height: "30px" }}
              disableElevation
              size="small"
              type="submit"
              variant="outlined"
              color="secondary"
              onClick={props.closeModal}
            >
              Cancel
            </Button>
          </div>
        </Form.Item>
      </Col>
    </Row>
  </div>


  return (
    <Modal
      footer={null}
      width={400}
      title={props.title}
      visible={props.visible}
      onCancel={props.onCancel}
    >
      <Form
        layout="vertical"
        name="basic"
        onFinish={handleSubmit}
        autoComplete="off"
      >
        {content}
      </Form>
    </Modal>
  );

};

export default UpdateManualAccountBalance;